import urlaForm from "./URLA-2019-Borrower-v28.pdf";

export const formsCatalog = [
  {
    id: "urla-2019",
    name: "Uniform Residential Loan Application (URLA) 2019",
    file: urlaForm,
    fileName: "URLA-2019-Borrower-v28.pdf",
    type: "application/pdf"
  }
];
